import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import * as IBooks from '../../../../interfaces/merchants/resources/books';
import BooksCalendarHeader from './BooksCalendarHeader';
import BooksCalendarTimeTable from './BooksCalendarTimeTable';

import css from './BooksCalendar.module.scss';

interface Props {
  loading: boolean;
  postable: boolean;
  className?: string;
  dates: string[];
  events: {
    checkinTimes: string[];
    dates: { [date: string]: IBooks.DateTimeSlot };
  };
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const BooksCalendar = ({
  loading,
  postable,
  className,
  dates,
  events,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksCalendar, className);

  return (
    <div className={classes}>
      <BooksCalendarHeader dates={dates} />
      <BooksCalendarTimeTable
        loading={loading}
        postable={postable}
        events={events}
        onClick={onClick}
      />
    </div>
  );
};

export default injectIntl(BooksCalendar);
